// ---------------------------------------------------------------------------
// AUTHOR PERSONNEL FILE
// Edit freely. Remove any link that isn't yours and add the ones that are.
// Set `bio` to a real paragraph whenever you want the redacted joke replaced.
// ---------------------------------------------------------------------------
export const AUTHOR = {
  displayName: "Tylegn",
  role: "Author of record",
  status: "ACTIVE",
  bio: null, // set a string here to replace the redacted file body
  fields: [
    { k: "Designation", v: "Author of record" },
    { k: "Known aliases", v: "Tylegn \u2014 on every system" },
    { k: "Origin", v: "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588" },
    { k: "Years of service", v: "\u2588\u2588" },
    { k: "Prior occupation", v: "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588" },
    { k: "Clearance", v: "Total. He wrote the file." }
  ],
  notes: [
    "Subject publishes under the name of a character who appears in Book One and returns in Book Five. The Directorate has logged this as either modesty or misdirection.",
    "Biography withheld at the subject's request.",
    "Known associates: Seren Vale, Maera Korr, Nym Selen, Cael Aran. All fictional. Probably."
  ],
  links: [
    { label: "X", handle: "@tylegn", href: "https://x.com/tylegn" },
    {
      label: "Instagram",
      handle: "@tylegn",
      href: "https://instagram.com/tylegn"
    },
    {
      label: "TikTok",
      handle: "@tylegn",
      href: "https://www.tiktok.com/@tylegn"
    }
  ]
};

// ---------------------------------------------------------------------------
// BOOK SIX - revealed only behind the Null Six puzzle
// ---------------------------------------------------------------------------
export const BOOK_SIX = {
  titleMask: "\u2588\u2588\u2588 \u2588\u2588\u2588\u2588\u2588 \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588",
  status: "IN PROGRESS \u00b7 NOT YET SEALED",
  dedication: "For the ones who \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588 \u2588\u2588\u2588\u2588 \u2588\u2588\u2588\u2588\u2588\u2588.",
  dedicationNote:
    "Partially recovered. The remainder has not been written yet \u2014 and that is not a redaction.",
  teaser: [
    "Five files. Five civilisations. Five sets of records that cannot all be true.",
    "The sixth is being written now. What it contains is the answer the first five books spend two thousand pages circling.",
    "The author will say this much, and no more: \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588 \u2588\u2588\u2588 \u2588\u2588 \u2588\u2588\u2588\u2588\u2588\u2588\u2588, and one of the five was \u2588\u2588\u2588\u2588 from the \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588.",
    "Nothing else. Not yet."
  ]
};

// ---------------------------------------------------------------------------
// THE NULL SIX PUZZLE
// Three fragments hidden across the landing page assemble into 02 18 54 - the
// moment the record ends. Add the missing interval (6.13 s) and you get the
// moment it resumes: 02:19:00. That is the code for the manual transmit line.
// ---------------------------------------------------------------------------
export const PUZZLE = {
  fragments: [
    {
      id: "f1",
      value: "02",
      where: "Link classification",
      note: "Recovered from a Link that refused to see a person."
    },
    {
      id: "f2",
      value: "18",
      where: "Exhibit 06-A",
      note: "Recovered from the row the Directorate would not expand."
    },
    {
      id: "f3",
      value: "54",
      where: "Book Six",
      note: "Recovered from underneath a title that does not exist yet."
    }
  ],
  prompt: "Enter the time the record resumes — hh:mm:ss",
  subPrompt:
    "Station standard. The record ends at 02:18:54 and 6.13 SECONDS are unaccounted for.",
  hintOne: "Three fragments. Assemble them in the order they are numbered.",
  hintTwo:
    "The record ends at 02:18:54. Add the missing 6.13 seconds: 54 + 6.13 crosses the minute.",
  hintThree:
    "02:18:54 + 6.13 s = 02:19:00 (.13). Enter 02:19:00.",
  answer: "02:19:00",
  accepted: [
    "021900",
    "21900",
    "0219",
    "219",
    "02190013",
    "2190013",
    "0219001",
    "219001",
    "0219000",
    "21900013",
    "1900",
    "190013"
  ],
  // Common wrong turn: reading 6.13 as six minutes thirteen seconds
  // (02:18:54 + 6:13) instead of 6.13 seconds.
  nearMiss: [
    "022467",
    "02246",
    "0224",
    "224",
    "022507",
    "02250",
    "0225",
    "225",
    "021867",
    "02186",
    "0218613",
    "0218",
    "218",
    "021854",
    "21854"
  ],
  nearMissMessage:
    "Seconds — not minutes. 6.13 s, and the clock only moves six seconds.",
  rejectMessage: "No distress condition detected."
};

// ---------------------------------------------------------------------------
// ROTATING ANOMALIES - 2 or 3 are armed at random on every visit
// ---------------------------------------------------------------------------
export const EGG_POOL = [
  { id: "konami", label: "Sequence anomaly" },
  { id: "sixthirteen", label: "Interval anomaly" },
  { id: "memorial", label: "Concourse anomaly" },
  { id: "console", label: "Diagnostic anomaly" },
  { id: "dedication", label: "Dedication anomaly" },
  { id: "personnel", label: "Personnel anomaly" }
];

export const REQUISITION_BOOKS = [
  "Book One \u2014 The Fracture",
  "Book Two \u2014 The Weight of Blood",
  "Book Three \u2014 The Living War",
  "Book Four \u2014 The Silent Mind",
  "Book Five \u2014 The Last Adaptation",
  "Book Six \u2014 [CLASSIFIED]",
  "The complete series"
];

export const REQUISITION_FORMATS = [
  "Signed hardcover",
  "Hardcover",
  "Paperback",
  "Ebook",
  "Audiobook",
  "No preference"
];
